import { render, staticRenderFns } from "./CellRendererAreaActions.vue?vue&type=template&id=00fcc0b7"
import script from "./CellRendererAreaActions.vue?vue&type=script&lang=js"
export * from "./CellRendererAreaActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports